// extracted by mini-css-extract-plugin
export default {"main":"d27f07671f _3ed9eab1b6","xmark":"_7a0bf2c83c","fl_img":"_2eeab8b091 _9e9b239bc7"};